import workspaceQuery from '../../../graphql/queries/purchases/PurchaseNoteTypeWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/purchases/PurchaseNoteTypeListQuery.graphql';
import instanceQuery from '../../../graphql/queries/purchases/PurchaseNoteTypeQuery.graphql';
import defaultQuery from '../../../graphql/queries/purchases/PurchaseNoteTypeDefault.graphql';
import mutationQuery from '../../../graphql/mutations/purchases/PurchaseNoteTypeMutation.graphql';
import fragment from '../../../graphql/fragments/purchases/PurchaseNoteTypeFragment.graphql';
import { Direction } from '../../schema/p4types';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseNoteType: EntityType = {
  type: 'PurchaseNoteType',
  title: 'Purchase Note Types',
  formTitle: 'Purchase Note Type',
  formUrl: '/Purchasing/NoteType/Details/',
  workspaceUrl: '/Purchasing/NoteType/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
    customVariables: () => {
      return {
        orderBy: 'title',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'PURCHASE_NOTE_TYPES',
};

export default PurchaseNoteType;
